import React from 'react';
import { Link } from 'react-router-dom';

const AboutSection: React.FC = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              为什么选择我们的<strong>服务</strong>？
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              我们拥有资深的<strong>生物信息学</strong>专家团队，具备丰富的<strong>基因组学</strong>、<strong>转录组学</strong>、<strong>蛋白质组学</strong>数据分析经验，为客户提供高质量、个性化的分析服务。
            </p>

            <div className="space-y-6 mb-8">
              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-lg mr-4 flex-shrink-0">
                  <i className="ri-team-line text-blue-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">专业团队</h3>
                  <p className="text-gray-600">拥有博士及以上学历的生物信息学专家，平均从业经验超过8年</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-lg mr-4 flex-shrink-0">
                  <i className="ri-settings-3-line text-blue-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">定制化服务</h3>
                  <p className="text-gray-600">根据客户具体需求，提供个性化的分析方案和专业建议</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-lg mr-4 flex-shrink-0">
                  <i className="ri-time-line text-blue-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">快速交付</h3>
                  <p className="text-gray-600">高效的分析流程，确保在约定时间内交付高质量的分析结果</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-lg mr-4 flex-shrink-0">
                  <i className="ri-shield-check-line text-blue-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">数据安全</h3>
                  <p className="text-gray-600">严格的数据保密协议，确保客户数据安全和隐私保护</p>
                </div>
              </div>
            </div>

            <div className="text-center">
              <Link 
                to="/contact"
                className="whitespace-nowrap cursor-pointer font-medium rounded-lg transition-all duration-200 flex items-center justify-center bg-blue-600 text-white hover:bg-blue-700 focus:ring-4 focus:ring-blue-200 px-8 py-4 text-lg inline-flex"
              >
                <i className="ri-phone-line mr-2"></i>
                联系我们
              </Link>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <img
              src="https://readdy.ai/api/search-image?query=Advanced%20bioinformatics%20laboratory%20setup%20with%20multiple%20computer%20monitors%20displaying%20DNA%20sequence%20analysis%2C%20genomic%20data%20visualization%20charts%2C%20molecular%20biology%20equipment%20and%20scientific%20instruments%2C%20modern%20clean%20laboratory%20environment%20with%20blue%20accent%20lighting%2C%20focus%20on%20technology%20and%20data%20without%20showing%20people&width=600&height=400&seq=about-lab-v2&orientation=landscape"
              alt="专业生物信息学实验室"
              className="rounded-xl shadow-lg w-full h-auto object-cover object-top"
            />
            <div className="absolute -bottom-6 -left-6 bg-blue-600 text-white p-6 rounded-lg shadow-lg">
              <div className="text-2xl font-bold">8+</div>
              <div className="text-sm">年平均经验</div>
            </div>
            <div className="absolute -top-6 -right-6 bg-white p-6 rounded-lg shadow-lg">
              <div className="text-2xl font-bold text-blue-600">100+</div>
              <div className="text-sm text-gray-600">成功项目</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
